'use strict';
import info2 from "./info1"

function Info2(scene, container) {
    this.scene = scene;
    this.children = [];

    this.childContainer = document.createElement('div');
    this.childContainer.className = 'cesium-html-layer';

    this.lastViewMatrix = null;
    this.lastBounds = null;
    this.isDirty = false;

    if (container) {
        container.appendChild(this.childContainer);
    } else {
        var cswidget = document.getElementsByClassName('cesium-viewer-cesiumWidgetContainer')[0];
        if (cswidget) {
            cswidget.parentNode.insertBefore(this.childContainer, cswidget.nextSibling);
        } else {
            throw new Cesium.DeveloperError('container is required.');
        }
    }

    scene.postRender.addEventListener(this._updateTracking, this);
}

Info2.prototype.add = function () {
    var child = new info2(this);
    this.children.push(child);
    return child;
};

Info2.prototype.remove = function (value) {
    value._setVisible(false);
    var index = this.children.indexOf(value);
    if (index >= 0) {
        this.children.splice(index, 1);
    }
};

Info2.prototype._markDirty = function () {
    this.isDirty = true;
};

Info2.prototype._updateTracking = function () {
    var newViewMatrix = this.scene.camera.viewMatrix;
    var newBounds = {width: this.scene.canvas.width, height: this.scene.canvas.height};

    if (!this.isDirty &&
        newViewMatrix.equals(this.lastViewMatrix) &&
        this.lastBounds &&
        newBounds.width === this.lastBounds.width &&
        newBounds.height === this.lastBounds.height) {
        return;
    }

    this.lastViewMatrix = newViewMatrix.clone();
    this.lastBounds = newBounds;

    var cameraPosition = this.scene.camera.positionWC;
    var ellipsoid = this.scene.mapProjection.ellipsoid;
    var occluder = new Cesium.EllipsoidalOccluder(ellipsoid, cameraPosition);
    var i;

    for (i = 0; i < this.children.length; i++) {
        this.children[i]._updateView(this.scene, this.scene.camera, occluder);
    }

    this.isDirty = false;
};

export default Info2;
